import { ArrowLeft, ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PasswordChangeForm from "../components/admin/PasswordChangeForm";
import { API } from "../data/siteData";

export default function AdminSecurityPage() {
  const navigate = useNavigate();
  const [state, setState] = useState("loading");

  useEffect(() => {
    let isActive = true;

    async function verifyAdministrator() {
      try {
        const response = await fetch(`${API}/auth/me`, { credentials: "include" });
        const user = response.ok ? await response.json() : null;
        if (!user || user.role !== "admin") throw new Error();
        if (isActive) setState("ready");
      } catch {
        navigate("/admin-login", { replace: true });
      }
    }

    verifyAdministrator();
    return () => {
      isActive = false;
    };
  }, [navigate]);

  if (state === "loading") {
    return <main className="portal-state" data-testid="admin-security-loading">Checking secure administrator access…</main>;
  }

  return (
    <main className="admin-security-page" data-testid="admin-security-page">
      <section className="admin-security-header">
        <Link className="text-button" to="/admin" data-testid="admin-security-return-link"><ArrowLeft size={16} />Control Room</Link>
        <div className="admin-security-heading">
          <ShieldCheck size={34} />
          <span className="eyebrow">Administrator security</span>
          <h1>PASSWORD &amp; SECURITY</h1>
          <p>Update the password used to enter the GAMEDAY Control Room.</p>
        </div>
      </section>
      <section className="admin-security-content" data-testid="admin-security-content">
        <div className="security-note" data-testid="admin-security-session-notice">
          <span className="eyebrow">Session protection</span>
          <p>Changing your password signs out other administrator sessions to keep the Control Room protected.</p>
        </div>
        <PasswordChangeForm />
      </section>
    </main>
  );
}